import { setDisplayErrorSnackBar } from "../../features/userSlice";
import {
  setCurrencyData,
  setDeepViewData,
  setDeepViewFetchedForKey,
  setDeepViewLoading,
} from "../../features/deepViewSlice";
import { deepViewEndpoints } from "../../services/api/deep-view.endpoints";
import store from "../../store";

// Hardcoded as per current requirements
export const DEEP_VIEW_DESTINATION_TABLE_ID = 2;
export const DEEP_VIEW_WEBSITE_SHARED_UID =
  "8e90926b9db2412d95af1a316479524e";

export interface DeepViewParams {
  brandId: string | number;
  startDate: string;
  endDate: string;
  // Ignored for now — the request always uses DEEP_VIEW_WEBSITE_SHARED_UID
  websiteSharedUids?: any[];
}

async function getDeepViewData(
  oauthTokenHeader: string,
  { brandId, startDate, endDate }: DeepViewParams,
) {
  const uids = [DEEP_VIEW_WEBSITE_SHARED_UID];

  if (!brandId || !startDate || !endDate) {
    console.error("Deep View: missing required parameters", {
      brandId,
      startDate,
      endDate,
    });
    return;
  }

  // The drawer opens from any cell of a row — only the row and the dashboard's
  // date range change what the API returns, so skip the call when neither did.
  const requestKey = [brandId, startDate, endDate, uids.join(",")].join("|");
  if (store.getState()?.deepView?.fetchedForKey === requestKey) return;

  try {
    store.dispatch(setDeepViewLoading(true));

    const response = await deepViewEndpoints.getDeepViewData(
      oauthTokenHeader,
      String(brandId),
      DEEP_VIEW_DESTINATION_TABLE_ID,
      startDate,
      endDate,
      uids,
    );

    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get deep view data");
    }

    store.dispatch(setDeepViewData(response?.data?.data));
    // Only mark as fetched on success, so a failed call is retried next time
    store.dispatch(setDeepViewFetchedForKey(requestKey));
  } catch (e: any) {
    store.dispatch(setDeepViewData(null));
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      }),
    );
  } finally {
    store.dispatch(setDeepViewLoading(false));
  }
}

async function getCurrenciesInDeepView(oauthTokenHeader: string) {
  try {
    const response =
      await deepViewEndpoints.getCurrenciesInDeepView(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get currencies in deep view");
    }
    const currencies = response?.data?.data;
    store.dispatch(setCurrencyData(currencies));
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText || "Something went wrong while fetching currencies.",
        type: "error",
      }),
    );
  }
}

export const DeepViewEndPointLogic = {
  getDeepViewData,
  getCurrenciesInDeepView,
};
